<p-card styleClass="map-card">
  <ng-template pTemplate="header">
    <app-card-header [header]="header"></app-card-header>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="map-container">
    <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls"></app-arcgis-map>
    </div>
  </ng-template>
</p-card>